// extracted by mini-css-extract-plugin
module.exports = {"button":"AddEditSuccessCriteriaDialog_button__1ulB9","title":"AddEditSuccessCriteriaDialog_title__eZPUl","llmButton":"AddEditSuccessCriteriaDialog_llmButton__v2vaN"};